<template>
  <footer :class="isLight ? 'bg-zinc-50 border-t border-zinc-200' : 'bg-[#0f0d0b]'">
    <div class="max-w-6xl mx-auto px-5 lg:px-8 py-12 lg:py-16">
      <div class="grid sm:grid-cols-2 lg:grid-cols-6 gap-x-8 gap-y-8 lg:gap-x-6 mb-10">
        <div class="sm:col-span-2 lg:col-span-2">
          <img :src="logoWordmark" alt="Avance Gestor" class="h-7 w-auto mb-3" />
          <p class="text-sm leading-relaxed mb-3" :class="isLight ? 'text-zinc-500' : 'text-white/40'">{{ footer.tagline }}</p>
          <a
            :href="`mailto:${footer.contactEmail}`"
            class="text-sm transition-colors"
            :class="isLight ? 'text-zinc-600 hover:text-primary-600' : 'text-white/60 hover:text-primary-400'"
          >
            {{ footer.contactEmail }}
          </a>
        </div>

        <div v-for="col in footer.columns" :key="col.title">
          <h4 class="text-xs font-semibold uppercase tracking-wider mb-3" :class="isLight ? 'text-zinc-400' : 'text-white/40'">{{ col.title }}</h4>
          <ul class="space-y-2">
            <li v-for="link in col.links" :key="link.label">
              <a
                :href="link.href"
                class="text-sm transition-colors"
                :class="isLight ? 'text-zinc-600 hover:text-primary-600' : 'text-white/60 hover:text-primary-400'"
                @click="onLinkClick($event, link)"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="pt-6 text-center" :class="isLight ? 'border-t border-zinc-200' : 'border-t border-white/10'">
        <p class="text-xs" :class="isLight ? 'text-zinc-400' : 'text-white/30'">&copy; {{ year }} Avance Gestor &mdash; Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { footer, theme } from '../../content/landingContent.js'
import { useLegalModal } from '../../composables/useLegalModal.js'
import { useSignupModal } from '../../composables/useSignupModal.js'
import logoWordmark from '../../assets/logo-resumida.svg'

const isLight = theme === 'light'

const year = new Date().getFullYear()

const { openLegalModal } = useLegalModal()
const { handleLoginClick } = useSignupModal()

// Termos/Privacidade abrem em modal aqui mesmo; ctrl/cmd//meio seguem o href
// normalmente, pra quem quiser abrir em outra aba. O "Entrar" mostra o aviso
// de manutenção quando ela está ligada.
const onLinkClick = (event, link) => {
  if (link.login) return handleLoginClick(event)
  if (!link.legalDocument) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
  event.preventDefault()
  openLegalModal(link.legalDocument)
}
</script>
